import { Field, Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { getApi, postApi, putApi } from "../../services/api/globalApi";
import {
    MapContainer,
    Marker,
    Popup,
    TileLayer,
    useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import { toast } from "react-toastify";
import MapWrapper from "./mapSearch/MapSearch";
import { useLocation, useNavigate } from "react-router";
import { motion } from "framer-motion"
import * as Yup from 'yup';
import Loadning from './../../components/common/loading/Loading.jsx'
import { FaUser } from "react-icons/fa";
import { context } from "../../context/context.js";

const Agent = () => {

    const { showLogutModal } = useContext(context)

    const location = useLocation()
    const navigate = useNavigate()

    console.log(location)
    const [agentData, setAgentData] = useState(null)

    const getAgentInfo = async () => {
        const path = `admin/users/${location?.pathname.slice(7)}`
        try {
            const data = await getApi({ path })
            console.log(data?.data.data)
            setPosition([[data?.data.data.lat, data?.data.data.long]])
            setAgentData(data?.data.data)
        } catch (error) {
            console.log(error)
        }
    }

    const [province, setProvince] = useState([])

    const getProvince = async () => {
        const params = { notPagination: 1, limit: 50 }
        try {
            const data = await getApi({ path: "admin/utils/provinces", params })
            console.log(data)
            setProvince(data?.data.data)

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getProvince()
    }, [])

    const formHandler = async (values, { resetForm }) => {
        setShowLoading(true)
        console.log(values)

        console.log(position)

        const latAndLong = position.length > 0 ? position[0] : [];
        const body = position.length > 0 ? { lat: latAndLong[0].toString().slice(0, 10), long: latAndLong[1].toString().slice(0, 10), ...values } : values;
        console.log(body)

        if (position.length > 0) {
            try {
                if (location?.pathname?.slice(7)) {
                    const response = await putApi({
                        path: `admin/users/${location?.pathname.slice(7)}`,
                        body: JSON.stringify(body)
                    });
                    toast.success("کاربر با موفقیت ویرایش شد.", {
                        position: "top-right",
                        closeOnClick: true
                    });
                    navigate('/agent-list')
                    console.log(response)
                } else {
                    const response = await postApi({
                        path: 'admin/users',
                        body: JSON.stringify(body)
                    });
                    console.log(response)
                    toast.success("کاربر با موفقیت اضافه شد.", {
                        position: "top-right",
                        closeOnClick: true
                    });
                }
                setPosition([])
                resetForm()
                setShowLoading(false)

            } catch (error) {
                console.error(error);
                toast.error(error?.response?.data?.errors[0].message, {
                    position: "top-right",
                    closeOnClick: true
                });
                setShowLoading(false)
                error?.response.status == 401 && showLogutModal();
            }

        } else {
            toast.warning('لطفا آدرس را روی نقشه انتخاب کنید', {
                position: "top-right",
                closeOnClick: true
            });
            setShowLoading(false)
        }
    }

    const [position, setPosition] = useState([])
    const [showLoading, setShowLoading] = useState(false)

    const MapEventsHandler = ({ handleMapClick }) => {
        useMapEvents({
            click: (e) => handleMapClick(e),
        });
        return null;
    };

    useEffect(() => {
        if (location?.pathname?.slice(7)) {
            getAgentInfo()
        }else{
            setAgentData(null)
            setPosition([])
        }
    }, [location.pathname])


    const handleMapClick = (e) => {
        const { lat, lng } = e.latlng;
        // alert(`Clicked at: ${lat}, ${lng}`);
        setPosition([[lat, lng]]);
    };

    const icon = new Icon({
        iconUrl: require('./../../assets/images/NoPath.png'),
        iconSize: [50, 50],
        iconAnchor: [20, 40],
        popupAnchor: [-25, -40],
    });

    const validate = Yup.object().shape({
        mobile: Yup.string()
            .min(11, 'موبایل باید 11 رقمی باشد!')
            .max(11, 'موبایل باید 11 رقمی باشد!')
            .required('وارد کردن موبایل الزامی است'),
        password: Yup.string()
            .min(5, 'رمز عبور خیلی کوتاه است!')
            .max(48, 'رمز عبور خیلی بلند است!'),
        name: Yup.string()
            .required('وارد کردن نام الزامی است'),
        address: Yup.string()
            .required('وارد کردن آدرس الزامی است'),
        officeMobile: Yup.string()
            .required('وارد کردن شماره شرکت الزامی است')
            .min(11, 'شماره شرکت باید 11 رقمی باشد!')
            .max(11, 'شماره شرکت باید 11 رقمی باشد!')
    });

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.5,
                // ease: [0, 0.71, 0.2, 1.01]
            }}
            className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

            <h6 className="mb-8 mt-2 text-gray-800 dark:text-white">{location.state ?
                <span className="flex items-center gap-x-2" > <FaUser size={26} />
                    ویرایش نماینده
                </span>
                :
                <span className="flex items-center gap-x-2" > <FaUser size={26} />
                    افزودن نماینده
                </span>
            }
            </h6>
            {showLoading && <Loadning />}

            <Formik
                enableReinitialize={true}
                initialValues={
                    agentData ?
                        {
                            name: agentData.name,
                            mobile: agentData.mobile,
                            province: agentData.province,
                            address: agentData.address,
                            officeMobile: agentData.officeMobile,
                            status: agentData.status,
                        }
                        :
                        {
                            name: '',
                            mobile: '',
                            password: '',
                            province: 'مازندران',
                            address: '',
                            officeMobile: '',
                            role: "user"
                        }
                }
                validationSchema={validate}
                onSubmit={formHandler}

            >
                {(formik) => (
                    <Form>
                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                            <div>
                                <label for="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نام نماینده</label>
                                <Field autocomplete="off" type="text" name="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="نام" />
                                {formik.errors.name && formik.touched.name ? (
                                    <p className="text-sm my-4 text-red-500">{formik.errors.name}</p>
                                ) : null}

                            </div>
                            <div>
                                <label for="mobile" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">موبایل</label>
                                <Field autocomplete="off" type="text" name="mobile" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="موبایل" />
                                {formik.errors.mobile && formik.touched.mobile ? (
                                    <p className="text-sm my-4 text-red-500">{formik.errors.mobile}</p>
                                ) : null}
                            </div>
                            <div>
                                <label for="officeMobile" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">شماره شرکت</label>
                                <Field autocomplete="off" type="text" name="officeMobile" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="شماره شرکت" />
                                {formik.errors.officeMobile && formik.touched.officeMobile ? (
                                    <p className="text-sm my-4 text-red-500">{formik.errors.officeMobile}</p>
                                ) : null}
                            </div>
                            <div>
                                <label for="province" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">استان</label>
                                <Field as="select" name="province"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                >
                                    {province ? province?.map((item, index) => {
                                        return <option key={index} value={item._id}>{item.name}</option>
                                    })
                                        : null}
                                </Field>
                                {formik.errors.province && formik.touched.province ? (
                                    <p className="text-sm my-4 text-red-500">{formik.errors.province}</p>
                                ) : null}
                            </div>

                            <div className="mb-6">
                                <label for="address" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">آدرس</label>
                                <Field as="textarea" name="address" type="text" className="min-h-10 max-h-32 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="آدرس" />
                                {formik.errors.address && formik.touched.address ? (
                                    <p className="text-sm my-4 text-red-500">{formik.errors.address}</p>
                                ) : null}
                            </div>

                            {!location.state ?
                                <div>
                                    <label for="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">رمز عبور</label>
                                    <Field autocomplete="off" type="password" name="password" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        placeholder="*****" />
                                    {formik.errors.password && formik.touched.password ? (
                                        <p className="text-sm my-4 text-red-500">{formik.errors.password}</p>
                                    ) : null}

                                </div>
                                :
                                <div>
                                    <label for="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">وضعیت</label>
                                    <Field as="select" name="status"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    >
                                        <option value={'active'}>فعال</option>
                                        <option value={'unActive'}>فیر فعال</option>
                                    </Field>
                                    {formik.errors.status && formik.touched.status ? (
                                        <p className="text-sm my-4 text-red-500">{formik.errors.status}</p>
                                    ) : null}
                                </div>
                            }

                        </div>

                        <div className="mb-6">
                            <p className=" text-gray-800 dark:text-white">آدرس روی نقشه</p>
                            <div className="w-11/12 mx-auto rounded-md py-4">
                                <MapContainer center={location?.state ? [location.state.data.lat, location.state.data.long] : [33.17434155100208, 53.67126877250738]} zoom={location?.state ? 15 : 5} style={{ height: '500px' }}>
                                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    <MapEventsHandler handleMapClick={handleMapClick} />
                                    {position.length > 0 && position?.map((item, index) => {
                                        return (
                                            <Marker key={index} position={item} icon={icon}>
                                                <Popup>
                                                    مختصات مکان نماینده
                                                </Popup>
                                            </Marker>
                                        )
                                    })}
                                    <MapWrapper />
                                </MapContainer>
                            </div>
                            {position?.length > 0 && <div className="flex items-center gap-x-6">
                                <p className=" text-gray-800 dark:text-white">مختصات آدرس : {position?.[0]}</p>
                                <button onClick={() => setPosition([])} type="button" className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                                    پاک کردن مختصات
                                </button>
                            </div>}

                        </div>
                        <div className="w-full flex justify-end">
                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                ثبت نماینده
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </motion.div >
    )
}

export default Agent